export const iconFontAwesomeHumanitarianWheatAwn = (
	<i className="fa-solid fa-wheat-awn"></i>
);
